<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";
import Plan from "@/components/widgets/plan-card";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    Stat,
    Plan,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      ip: null,

      statData: [
        { title: "Status", value: "-" },
      ],

      client: null,
      plan: null,
      plans: null,

      choose: {
        modal: false,
        loading: false,
        id: '',
        name: '',
        description: '',
        value: '',
        discount: 0,
        total: 0,
        service: [],
      },

      coupon: {
        code: '',
        loading: false,
        type: '',
        value: '',
      },

      confirm: {
        loading: false,
      },

      payment: {
        loading: false,
      },

      payments: null,

      upgrade: {
        modal: false,
        step: 'list',
        fetchLoading: false,
        loading: false,
        list: [],
        id: '',
        name: '',
        upgrade_value: 0,
        value: 0,
      },
    };
  },
  methods: {
    getIp() {
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
          if (data.ip) {
            this.ip = data.ip;
          }
        });
    },
    getCurrent() {
      this.plan = null;

      this.statData = null;

      this.choose.modal = false;
      this.choose.loading = false;
      this.choose.id = '';
      this.choose.name = '';
      this.choose.description = '';
      this.choose.value = '';
      this.choose.service = [];

      this.upgrade.modal = false;
      this.upgrade.step = 'list';
      this.upgrade.list = [];
      this.upgrade.id = '';
      this.upgrade.name = '';
      this.upgrade.upgrade_value = 0;
      this.upgrade.value = 0;

      api
        .get('subscriptions/current')
        .then((response) => {
          if (response.data.status == 'success') {
            this.client = response.data.client
            this.plan = response.data.current

              this.statData = [
                { title: "Status", value: this.client.status },
              ]
          }
        })
    },
    getPlans() {
      this.plans = null;

      api
        .get('subscriptions')
        .then((response) => {
          if (response.data.status == 'success') {
            this.plans = response.data.list;
          }
        })
    },
    showChoose(plan) {
      this.choose.modal = true;
      this.choose.id = plan.id;
      this.choose.name = plan.name;
      this.choose.description = plan.description;
      this.choose.value = plan.value;
      this.choose.discount = 0;
      this.choose.total = 0;
      this.choose.service = plan.service;
      this.coupon.code = '';
      this.coupon.loading = false;
      this.coupon.type = '';
      this.coupon.value = '';
    },
    applyCoupon() {
      if (!this.coupon.code) return;

      this.coupon.loading = true;

      api
        .post('subscriptions/coupons/check', {
          code: this.coupon.code,
        })
        .then((response) => {
          if (response.data.status == 'success') {
            this.coupon.type = response.data.coupon.type;
            this.coupon.value = response.data.coupon.value;

            if (this.coupon.type == '%') {
              this.choose.discount = this.choose.value * this.coupon.value / 100;
            } else {
              this.choose.discount = parseFloat(this.coupon.value);
            }

            this.choose.total = this.choose.value - this.choose.discount;
            if (this.choose.total < 0) {
              this.choose.total = 0;
            }

            this.$toast.success('O cupom de desconto foi aplicado com sucesso.');
          } else {
            this.coupon.type = '';
            this.coupon.value = '';
            this.choose.discount = 0;
            this.choose.total = 0;
            this.$toast.error(response.data.message);
          }
        })
        .finally(() => {
          this.coupon.loading = false;
        });
    },
    choosePlan() {
      if (this.choose.id) {
        this.choose.loading = true;

        api
          .post('subscriptions/choose', {
            id: this.choose.id,
            coupon: this.coupon.code,
          })
          .then((response) => {
            if (response.data.status == 'success') {
              this.$router.push('/subscriptions/' + response.data.order.id);
            } else {
              this.$toast.error(response.data.message);
            }
          })
          .catch((error) => {
            if (error) {
              this.choose.modal = false;
              this.choose.loading = false;
            }
          })
          .finally(() => {
            this.choose.modal = false;
            this.choose.loading = false;
          });
      }
    },
    changePlan() {
      this.client = null;
      this.plan = null;
      this.plans = null;

      api
        .post('subscriptions/change')
        .then((response) => {
          if (response.data.status == 'success') {
            this.getCurrent();
            this.getPlans();
            this.getPayments()
          } else {
            this.$toast.error(response.data.message);
          }
        })
    },
    confirmPlan() {
      this.confirm.loading = true;

      api
        .post('subscriptions/confirm', {
          ip: this.ip
        })
        .then((response) => {
          if (response.data.status == 'success') {
            this.getCurrent();
          } else {
            this.$toast.error(response.data.message);
          }
        })
        .catch(() => {
        })
        .finally(() => {
          this.confirm.loading = false;
        });
    },
    makePayment() {
      this.payment.loading = true;
    },
    getPayments() {
      this.payments = null;

      api
        .get('subscriptions/payments')
        .then((response) => {
          if (response.data.status == 'success') {
            this.payments = response.data.list;
          } else {
            this.payments = null;
          }
        })
    },
    openUpgradeModal() {
      this.upgrade.fetchLoading = true;
      api
        .get('subscriptions/upgrades')
        .then((response) => {
          if (response.data.status == 'success') {
            this.upgrade.list = response.data.list || [];
            this.upgrade.step = 'list';
            if (this.upgrade.list.length === 0) {
              this.$toast.success('Você já está no plano mais alto disponível.');
            } else {
              this.upgrade.modal = true;
            }
          } else if (response.data.status == 'empty') {
            this.$toast.error('Não foi possível carregar os upgrades para sua conta.');
          }
        })
        .catch(() => {
          this.$toast.error('Não foi possível carregar os upgrades.');
        })
        .finally(() => {
          this.upgrade.fetchLoading = false;
        });
    },
    showUpgradeConfirm(row) {
      this.upgrade.id = row.id;
      this.upgrade.name = row.name;
      this.upgrade.upgrade_value = row.upgrade_value;
      this.upgrade.value = row.value;
      this.upgrade.step = 'confirm';
    },
    upgradeBackToList() {
      this.upgrade.step = 'list';
    },
    resetUpgradeModal() {
      this.upgrade.step = 'list';
      this.upgrade.loading = false;
    },
    submitUpgrade() {
      if (!this.upgrade.id) {
        return;
      }
      this.upgrade.loading = true;
      api
        .post('subscriptions/upgrade', {
          id: this.upgrade.id,
        })
        .then((response) => {
          if (response.data.status == 'success') {
            this.upgrade.modal = false;
            this.resetUpgradeModal();
            this.$router.push('/subscriptions/' + response.data.order.id);
          } else {
            this.$toast.error(response.data.message || 'Não foi possível gerar o upgrade.');
          }
        })
        .catch(() => {
          this.$toast.error('Não foi possível gerar o upgrade.');
        })
        .finally(() => {
          this.upgrade.loading = false;
        });
    },
  },
  mounted() {
    this.getIp()
    this.getCurrent()
    this.getPlans()
    this.getPayments()
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/subscriptions">Meu Plano</router-link></li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Meu Plano</h3>
        <p></p>
      </div>
    </div>

    <div v-if="!client && !plans" class="text-center">
      <b-spinner class="ml-2 align-middle" variant="default" role="status"></b-spinner>
    </div>
    <template v-else-if="client && client.status == 'await_plan'">
      <div v-if="plans && plans.length > 0">
        <div class="row">
          <div class="col-lg-3" v-for="(row, index) in plans" :key="index">
            <div class="card">
              <div class="card-body">
                <h5 class="mb-0 text-center">{{ row.name }}</h5>
                <h2 class="mb-3 text-center">{{ row.value | currency }}</h2>
                <button class="btn btn-default btn-lg btn-block text-uppercase" v-on:click="showChoose(row)">
                  Escolher
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center">
        Nenhum plano disponível no momento.
      </div>
    </template>
    <template v-else-if="client && client.status == 'plan_chosen'">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h5 class="mb-0">Você escolheu o plano</h5>
        <button class="btn btn-outline-default py-1 rounded-sm" v-on:click="changePlan();">Alterar</button>
      </div>
      <Plan :plan="plan" />
      <div class="row">
        <div v-for="stat of statData" :key="stat.icon" class="col-md-3 col-lg-3 col-xl-3">
          <Stat :title="stat.title" :value="stat.value" />
        </div>
      </div>
    </template>
    <template v-else-if="client && client.status == 'active'">
      <Plan :plan="plan">
        <template v-slot:footer>
          <button
            type="button"
            class="btn btn-default btn-block"
            v-on:click="openUpgradeModal()"
            :disabled="upgrade.fetchLoading"
          >
            <i class="bx bx-up-arrow-alt align-middle mr-1"></i>
            Fazer upgrade
            <b-spinner v-if="upgrade.fetchLoading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
        </template>
      </Plan>
      <div class="row">
        <div v-for="stat of statData" :key="stat.title" class="col-md-3 col-lg-3 col-xl-3">
          <Stat :title="stat.title" :value="stat.value" />
        </div>
      </div>
    </template>
    <template v-else-if="client && client.status == 'overdue'">
      <Plan :plan="plan" />
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center mb-3">
            <div class="mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" style="fill: rgba(255, 0, 0, 1);">
                <path d="M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM13 17h-2v-2h2v2zm0-4h-2V7h2v6z"></path>
              </svg>
            </div>
            <div>
              <strong>O pagamento do seu plano está em atraso!</strong>
            </div>
          </div>
          <button class="btn btn-default btn-block mt-3" v-on:click="makePayment();" :disabled="this.payment.loading">
            Realizar pagamento
            <b-spinner v-if="payment.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
        </div>
      </div>
    </template>
    <template v-else-if="client && client.status == 'suspended'">
      <Plan :plan="plan" />
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center mb-3">
            <div class="mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" style="fill: rgba(255, 0, 0, 1);">
                <path d="M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM13 17h-2v-2h2v2zm0-4h-2V7h2v6z"></path>
              </svg>
            </div>
            <div>
              <strong>O seu plano está suspenso por falta de pagamento!</strong>
            </div>
          </div>
          <button class="btn btn-default btn-block mt-3" v-on:click="makePayment();" :disabled="this.payment.loading">
            Realizar pagamento
            <b-spinner v-if="payment.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
        </div>
      </div>
    </template>
    <template v-else-if="client && client.status == 'inactive'">
      <Plan :plan="plan" />
    </template>

    <fieldset v-if="payments && payments.length > 0">
      <legend>Histórico</legend>
      <div class="table-responsive">
        <table class="table table-centered table-nowrap">
          <thead class="thead-light">
            <tr>
              <th>Plano</th>
              <th>Valor</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in payments" :key="row.index">
              <td>
                {{ row.plan }}
              </td>
              <td>{{ row.value | currency }}</td>
              <td>
                <span class="badge badge-soft-danger font-size-13" v-if="row.status == 'pending'">PENDENTE</span>
                <span class="badge badge-soft-success font-size-13" v-else-if="row.status == 'approved'">APROVADO</span>
                <span class="badge badge-soft-warning font-size-13" v-else-if="row.status == 'canceled'">CANCELADO</span>
              </td>
              <td class="text-right">
                <router-link v-if="row.order.id" :to="'/subscriptions/' + row.order.id" class="btn btn-default btn-rounded">
                  Ver
                  <i class="mdi mdi-arrow-right ml-1"></i>
                </router-link>
                <button v-else class="btn btn-default btn-rounded" disabled>
                  Ver
                  <i class="mdi mdi-arrow-right ml-1"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </fieldset>

    <b-modal v-model="choose.modal" modal-class="modal-bottom" hide-header hide-footer>
      <div>
        <h4>Confirmar escolha</h4>
        <p>Confirma a escolha do plano <strong>{{ choose.name }}</strong>?</p>
        <template v-if="choose.discount > 0">
          <h5 class="mb-0 text-muted"><s>{{ choose.value | currency }}</s></h5>
          <h4 class="mb-0">{{ choose.total | currency }}</h4>
        </template>
        <template v-else>
          <h4 class="mb-0">{{ choose.value | currency }}</h4>
        </template>
        <div class="my-4">
          <b-input-group>
            <b-form-input v-model="coupon.code" type="text" placeholder="Possui um cupom de desconto?" :disabled="coupon.loading"></b-form-input>
            <button type="button" style="border-top-left-radius: 0; border-bottom-left-radius: 0;" class="btn btn-default" v-on:click="applyCoupon()" :disabled="coupon.loading">
              <b-spinner v-if="coupon.loading" small class="align-middle" variant="white" role="status"></b-spinner>
              <span v-else>Aplicar</span>
            </button>
          </b-input-group>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-default btn-lg mr-3" v-on:click="choosePlan()" :disabled="choose.loading || coupon.loading">
            Confirmar
            <b-spinner v-if="choose.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
          <a class="btn btn-outline-link" v-on:click="choose.modal = false">Fechar</a>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="upgrade.modal"
      modal-class="modal-bottom"
      hide-header
      hide-footer
      @hidden="resetUpgradeModal"
    >
      <div v-if="upgrade.step === 'list'">
        <h4 class="mb-3">Upgrade de plano</h4>
        <p class="text-muted mb-3">Valor a pagar é a diferença em relação ao seu plano atual.</p>
        <div class="list-group list-group-flush mb-3">
          <div
            v-for="row in upgrade.list"
            :key="row.id"
            class="list-group-item d-flex flex-column flex-md-row justify-content-between align-items-md-center px-0"
          >
            <div class="mb-2 mb-md-0">
              <strong>{{ row.name }}</strong>
              <div class="small text-muted">Plano: {{ row.value | currency }} — Upgrade: {{ row.upgrade_value | currency }}</div>
            </div>
            <button type="button" class="btn btn-default btn-sm" v-on:click="showUpgradeConfirm(row)">
              Continuar
            </button>
          </div>
        </div>
        <a class="btn btn-outline-link" v-on:click="upgrade.modal = false">Fechar</a>
      </div>
      <div v-else>
        <h4 class="mb-3">Confirmar upgrade</h4>
        <p>
          Confirma o upgrade para o plano <strong>{{ upgrade.name }}</strong>?
          <br />
          Valor do upgrade: <strong>{{ upgrade.upgrade_value | currency }}</strong>
          <span class="text-muted"> (plano {{ upgrade.value | currency }})</span>
        </p>
        <div class="d-flex flex-wrap justify-content-between align-items-center">
          <div>
            <button
              type="button"
              class="btn btn-default btn-lg mr-2 mb-2"
              v-on:click="submitUpgrade()"
              :disabled="upgrade.loading"
            >
              Confirmar
              <b-spinner v-if="upgrade.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
            </button>
            <button type="button" class="btn btn-outline-default mb-2" v-on:click="upgradeBackToList()" :disabled="upgrade.loading">
              Voltar
            </button>
          </div>
          <a class="btn btn-outline-link mb-2" v-on:click="upgrade.modal = false">Fechar</a>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>